import React from "react";
import { Box, Typography, Button } from "@mui/material";

const LotteryTable = ({ applicationTypes = [], onConfirmDialog }) => {
    return (
        <Box
            sx={{
                border: "1px solid #dcdcdc",
                borderRadius: 1.5,
                overflowX: "auto",
                mt: 1,
            }}
        >
            {/* Use table layout for perfect column alignment and full-width scroll */}
            <Box sx={{ display: "table", width: "100%" }}>
                {/* Header */}
                <Box
                    sx={{
                        display: "table-row",
                        backgroundColor: (theme) => theme.palette.action.hover,
                        borderBottom: "1px solid",
                        borderColor: (theme) => theme.palette.divider,
                    }}
                >
                    {["Τύπος Αίτησης", "Όριο", "Πλήθος", "Κατάσταση", "Ενέργεια"].map(
                        (header, i) => (
                            <Box
                                key={i}
                                sx={{
                                    display: "table-cell",
                                    fontWeight: 600,
                                    px: 1,
                                    py: 1,
                                    textAlign: i === 0 ? "left" : "right",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {header}
                            </Box>
                        )
                    )}
                </Box>

                {/* Rows */}
                {applicationTypes.map((type, idx) => {
                    const requiresLottery = type.total > type.limit;

                    return (
                        <Box
                            key={idx}
                            sx={{
                                display: "table-row",
                                backgroundColor: (theme) => (idx % 2 === 0 ? theme.palette.background.paper : theme.palette.action.hover),
                                borderBottom: idx < applicationTypes.length - 1 ? "1px solid" : "none",
                                borderColor: (theme) => theme.palette.divider,
                            }}
                        >
                            {/* Τύπος Αίτησης */}
                            <Box
                                sx={{
                                    display: "table-cell",
                                    px: 1,
                                    py: 1.2,
                                    fontWeight: 600,
                                    color: "primary.main",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {type.type}
                            </Box>

                            {/* Όριο */}
                            <Box
                                sx={{
                                    display: "table-cell",
                                    px: 1,
                                    py: 1.2,
                                    fontWeight: 600,
                                    textAlign: "right",
                                }}
                            >
                                {type.limit}
                            </Box>

                            {/* Πλήθος */}
                            <Box
                                sx={{
                                    display: "table-cell",
                                    px: 1,
                                    py: 1.2,
                                    fontWeight: 600,
                                    textAlign: "right",
                                }}
                            >
                                {type.appCount}
                            </Box>

                            {/* Κατάσταση */}
                            <Box
                                className={type?.css}
                                sx={{
                                    display: "table-cell",
                                    px: 1,
                                    py: 1.2,
                                    textAlign: "right",
                                    fontWeight: 600,

                                    whiteSpace: "nowrap",
                                }}
                            >
                                {type?.status}
                            </Box>

                            {/* Ενέργεια */}
                            <Box
                                sx={{
                                    display: "table-cell",
                                    px: 1,
                                    py: 1.2,
                                    textAlign: "right",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={!type?.needToDraw}
                                    onClick={() => onConfirmDialog(type)}
                                    sx={{
                                        fontWeight: 600,
                                        borderRadius: 2,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Κλήρωση
                                </Button>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default LotteryTable;
